import { Component, OnInit } from '@angular/core';
import { CompanyParamsService } from 'src/app/core/services/company-params.service';
import { Utils } from '../../utils';

@Component({
  selector: 'app-heart-header',
  templateUrl: './heart-header.component.html',
  styleUrls: ['./heart-header.component.scss']
})
export class HeartHeaderComponent implements OnInit {

  constructor(
    public companyParamsService: CompanyParamsService,
  ) { }

  ngOnInit(): void {
  }

  goFavorites() {
    const urlFavorites: any =
      this.companyParamsService.getNameUrl() +
      '/wishlist';
    Utils.openNewTab(urlFavorites);
  }

}
